/* eslint-disable consistent-return -- needed */
import { useEffect, useRef, useState } from 'react';

const useVisibilityTracker = (label, onVisible, threshold = 0.5) => {
  const ref = useRef(null);
  const [hasTracked, setHasTracked] = useState(false);

  useEffect(() => {
    if (hasTracked) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasTracked) {
          setHasTracked(true); // ensure only one trigger
          if (onVisible) onVisible(label);
          observer.disconnect(); // disconnect to stop observing
        }
      },
      { threshold }
    );

    const { current } = ref;
    if (current) observer.observe(current);

    return () => observer.disconnect();
  }, [label, onVisible, threshold, hasTracked]);

  return ref;
};

export default useVisibilityTracker;

/* eslint-enable consistent-return -- needed */
